<!--The content below is only a placeholder and can be replaced.-->
<div class="page">
    <div class="page-header">
        <app-head></app-head>
    </div>
    <div class="page-body">
        <app-body></app-body>
    </div>
    <div class="page-notice">
        <app-notice></app-notice>
    </div>
    <div class="page-dialog">
        <app-dialog></app-dialog>
    </div>
</div>
